import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { NXDProvider } from '@n26/nxd'

import { App } from './App'
import { useSystemTheme } from '@/shared/hooks/useSystemTheme'
import './styles/fonts.css'
import '@n26/nxd/styles.css'
import './styles/globals.css'

const Root = () => {
  useSystemTheme()
  return (
    <NXDProvider locale='en'>
      <App />
    </NXDProvider>
  )
}

const renderApp = () => {
  const container = document.getElementById('root')
  if (!container) throw new Error('#root not found')
  createRoot(container).render(
    <StrictMode>
      <Root />
    </StrictMode>
  )
}

if (import.meta.env.DEV) {
  const { worker } = await import('@/mocks/browser')
  await worker.start({ onUnhandledRequest: 'bypass' })
}
renderApp()
